import React from 'react'
import { MANTHLY_BALANCE_ITEM_DETAIL } from '../urls'
import { usePutRequest } from '../hooks/request'
import ServerError from './componentsFinance/common/ServerError'
import ManthlyBalanceItemForm from './ManthlyBalanceItemForm'

export default function ManthlyBalanceItemUpdate({ onCancel, onSuccess, reportItem, finance, rotationId }) {
    const url = MANTHLY_BALANCE_ITEM_DETAIL.replace('{id}', reportItem.id)
    const rotationItemUpdate = usePutRequest({ url })

    async function onSubmit(data) {
        const { success } = await rotationItemUpdate.request({ data })

        if (success) {
            onSuccess()
        }
    }

    return (
        <div>
            <b>Изменить данные</b><br /><br />
            <ServerError error={rotationItemUpdate.error} />
            <ManthlyBalanceItemForm
                initialValues={reportItem}
                onSubmit={onSubmit}
                onCancel={onCancel}
                rotationId={rotationId}
                finance={finance}
                loading={rotationItemUpdate.loading} />
        </div>
    )
}
